export default __webpack_public_path__ + "static/media/icon-catalogo.3e464ce7.svg";